import React from 'react';
import { GridItem } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const BaseDocumentCell = Cell => ({
  document,
  requirement,
  recordId,
  colSpan = 2,
  insuredId = null,
  hideOptions = false
}) => (
  <GridItem alignSelf="center" colSpan={colSpan} justifySelf="center">
    <Cell
      document={document}
      hideOptions={hideOptions}
      insuredId={insuredId}
      recordId={recordId}
      requirement={requirement}
    />
  </GridItem>
);

BaseDocumentCell.propTypes = {
  colSpan: PropTypes.number,
  document: PropTypes.shape({
    id: PropTypes.number,
    status: PropTypes.string,
    statusLoading: PropTypes.bool
  }),
  requirement: PropTypes.shape({
    status: PropTypes.string,
    insuranceRequirementId: PropTypes.number,
    insuranceDocumentTypeId: PropTypes.number
  }),
  recordId: PropTypes.number,
  insuredId: PropTypes.number,
  hideOptions: PropTypes.bool
};

export default BaseDocumentCell;
